import { create } from 'zustand';

interface TrainerShellAssistState {
  /** Footer AppLayout visible : déclencheurs intégrés au pied de page (pas de FAB flottants). */
  footerAssistActive: boolean;
  setFooterAssistActive: (active: boolean) => void;
  a11yOpen: boolean;
  setA11yOpen: (open: boolean) => void;
  supportChatOpen: boolean;
  setSupportChatOpen: (open: boolean) => void;
}

export const useTrainerShellAssist = create<TrainerShellAssistState>((set) => ({
  footerAssistActive: false,
  setFooterAssistActive: (footerAssistActive) => set({ footerAssistActive }),
  a11yOpen: false,
  setA11yOpen: (a11yOpen) => set({ a11yOpen }),
  supportChatOpen: false,
  setSupportChatOpen: (supportChatOpen) => set({ supportChatOpen }),
}));
